import React, { useContext, useEffect } from "react";
import Cart from "../../components/cart/Cart";
import { CartContext } from "../../util/context";
import { useNavigate } from "react-router-dom";
import { inactiveState } from "../../util/inactivity";

export default function CartPage() {
  const ctx = useContext(CartContext);
  const navigate = useNavigate();

  window.onload = function () {
    inactiveState(ctx, navigate);
  };

  useEffect(() => {
    if (!ctx.isLoggedIn) {
      navigate("/login");
    }
  }, [ctx]);
  return <Cart />;
}
